module.exports = __webpack_public_path__ + "img/gastliches_kinzigtal.1dec7538.png";